module.exports = __webpack_public_path__ + "static/media/driver_placeholder.aa6b8003.png";